<template>
  <Layout
    username="Agent"
    current-page="Sales"
    link-to-edit="/agent-dashboard/edit-profile"
  >
    <template slot="menuItems">
      <li
        v-for="{ title, icon, path } in menu"
        :key="title"
        class="nav-item"
      >
        <MenuItems
          :menu-item="title"
          :icon-menu="icon"
          :to-where="path"
        />
      </li>
    </template>
    <template slot="content">
      <div class="jumbotron">
        <div class="my-3">
          Total: {{ sales.count }}
        </div>
        <div class="row justify-content-between mb-3">
          <div class="col-4">
            <form>
              <input
                id="inlineFormInputName2"
                v-model="searchQuery"
                type="text"
                class="form-control mb-2 mr-sm-2"
                placeholder="Type to search..."
                @input="onQueryChange"
              >
            </form>
          </div>
        </div>

        <sales-table :data="sales.data" />
        <pagination
          :pages="sales.pages"
          :on-paginate="onPaginate"
          :current-page="currentPage"
        />
      </div>
    </template>
  </Layout>
</template>

<script>
import { mapGetters } from "vuex";
import Layout from "../../components/Layout";
import MenuItems from "../../components/MenuItems";
import SalesTable from "../../components/Tables/SalesTable.vue";
import Pagination from "../../components/Pagination.vue";
export default {
  name: "Recordsale",
  components: {
    Layout,
    MenuItems,
    SalesTable,
    Pagination,
  },
  data() {
    return {
      menu: [
        {
          title: "Record Sale",
          icon: "fa fa-cash-register",
          path: "/agent",
        },
        {
          title: "Drafted Records",
          icon: "fa fa-edit",
          path: "/agent/drafts",
        },
        {
          title: "View Sales",
          icon: "fa fa-table",
          path: "/agent/sales",
        },
      ],
      currentPage: 1,
      searchQuery: "",
      timer: null,
    };
  },
  computed: {
    ...mapGetters({ sales: "sales/agentSales" }),
  },
  beforeCreate() {
    this.$store.dispatch("sales/getSales");
  },
  methods: {
    onQueryChange() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.$store.dispatch("sales/getSales", {
          search: this.searchQuery,
        });
      }, 500);
    },
    onPaginate(value) {
      if (value > 0 && value < this.sales.pages + 1) {
        this.currentPage = value;
        this.$store.dispatch("sales/getSales", {
          search: this.searchQuery,
          page: this.currentPage,
        });
      }
    },
  },
};
</script>

<style scoped>
.nav-item {
  cursor: pointer;
}

.nav-item .nav-link:hover {
  color: #8bc34a;
}

.jumbotron {
  overflow-x: scroll;
}
</style>
